module.exports = __webpack_public_path__ + "img/PolarisMarkets-logo.838741b3.png";